"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WagonLoad = function WagonLoad(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "23.999",
    height: "22.868",
    viewBox: "0 0 23.999 22.868",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-265.04 -1234.5)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M288.92,1242.18a.494.494,0,0,0-.38-.18H288a3.618,3.618,0,0,0-3.96-3.5,3.818,3.818,0,0,0-1.27.211,6,6,0,0,0-11.461,0,3.854,3.854,0,0,0-1.269-.211,3.585,3.585,0,0,0-3.96,3.5h-.54a.493.493,0,0,0-.38.18.466.466,0,0,0-.11.41l1.65,10.031a2.888,2.888,0,0,0,1.859,2.209c-.009-.109-.019-.22-.019-.33a3.5,3.5,0,0,1,7,0,2.737,2.737,0,0,1-.04.5h3.08a2.737,2.737,0,0,1-.04-.5,3.5,3.5,0,0,1,7,0c0,.11-.01.221-.02.33a2.859,2.859,0,0,0,1.85-2.209l1.66-10.031A.472.472,0,0,0,288.92,1242.18Zm-21.84-.18c.18-1.809,1.32-2.5,2.96-2.5a2.878,2.878,0,0,1,1.38.34.539.539,0,0,0,.45.011.5.5,0,0,0,.269-.36,5,5,0,0,1,9.8,0,.5.5,0,0,0,.27.36.54.54,0,0,0,.45-.011,2.878,2.878,0,0,1,1.38-.34A2.616,2.616,0,0,1,287,1242Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5",
    transform: "translate(269.54 1252)"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5",
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 279.172, 1252.433)"
  })));
};

WagonLoad.propTypes = {};
WagonLoad.defaultProps = {};
var _default = WagonLoad;
exports["default"] = _default;